import {
  ButtonTracking,
  ScreenTracking,
  SCREEN_ASSET_ID
} from '../../domain/amplitude'

export type EmailVerificationData = {
  type: 'email'
  code: string
}

export type EmailVerificationProps = {
  email: string
  isError?: boolean
  isInvalid?: boolean
  isLoading?: boolean
  emailNewCode: () => Promise<void>
  onSubmitCode: (data: EmailVerificationData) => Promise<void>
}

export const EMAIL_SCREEN = 'application_email'

export const ScreenOpenedEvent: ScreenTracking = {
  heading: 'Verify your Email',
  screen: EMAIL_SCREEN,
  asset_id: SCREEN_ASSET_ID,
  from_screen: 'signUp'
}

export const NextButtonEvent: ButtonTracking = {
  asset_id: 'nextButton',
  asset_text: 'NEXT',
  screen: EMAIL_SCREEN
}

export const NewCodeButtonEvent: ButtonTracking = {
  asset_id: 'newCodeButton',
  asset_text: 'Get a new code',
  screen: EMAIL_SCREEN
}
